export const REDACT = '[Filtered]';

const SENSITIVE_KEY_RE =
    /(token|auth|authentication|authorization|password|secret|apikey|api_key|session|cookie|ssn|email|phone|address|jwt|bearer|payment|payments|paypal|stripe|coinpayments|firstname|lastname|name)/i;

const SENSITIVE_HEADER_RE = /authorization|cookie|set-cookie|x-api-key/i;

/** Replaces values of sensitive HTTP headers (authorization, cookie, x-api-key) with the REDACT placeholder. */
export function redactHeaders(headers: Record<string, any>) {
    const out: Record<string, any> = {};
    for (const [k, v] of Object.entries(headers || {})) {
        out[k] = SENSITIVE_HEADER_RE.test(k) ? REDACT : v;
    }
    return out;
}

/** Recursively replaces values of sensitive-named keys (token, auth, password, email, etc.) with the REDACT placeholder, up to maxDepth. */
export function redactDeep(value: any, depth = 0, maxDepth = 8): any {
    if (depth > maxDepth) return '[Truncated]';
    if (value == null) return value;

    if (typeof value !== 'object') return value;

    if (Array.isArray(value)) {
        return value.map((v) => redactDeep(v, depth + 1, maxDepth));
    }

    const out: any = {};
    for (const [k, v] of Object.entries(value)) {
        if (SENSITIVE_KEY_RE.test(k)) {
            out[k] = REDACT;
            continue;
        }

        if (k.toLowerCase() === 'headers' && v && typeof v === 'object') {
            out[k] = redactHeaders(v as Record<string, any>);
            continue;
        }

        out[k] = redactDeep(v, depth + 1, maxDepth);
    }
    return out;
}
